import React, { useState } from 'react';
import { Paths } from '../shared/url_helpers';
import CsrfForm from '@reverbdotcom/commons/src/csrf_form';
import { RCAccordion, RCAlertBox, RCButton, RCRadioGroup, RCTextInput } from '@reverbdotcom/cadence/components';
import { CURRENCY_DESCRIPTION } from '@reverbdotcom/commons/src/currency_descriptions';

export const FULL = 'full';
export const PARTIAL = 'partial';
type RefundType = 'full' | 'partial';

interface IProps {
  orderId: number;
  presentmentCurrency: string;
}

interface IManualDcViaPaypalRefundFormData {
  refundType: RefundType;
  refundAmount: string;
}

export function AdminCreateManualDCViaPaypalRefundForm({ orderId, presentmentCurrency }: IProps) {
  const [formData, setFormData] = useState<IManualDcViaPaypalRefundFormData>({
    refundType: FULL,
    refundAmount: '',
  });

  const setFormField = (fieldName, value) => {
    setFormData((state) => ({
      ...state,
      [fieldName]: value,
    }));
  };

  const handleRefundTypeChange = (event) => {
    setFormField('refundType', event.target.value);
  };

  const handleRefundAmountChange = (event) => {
    setFormField('refundAmount', event.target.value);
  };

  return (
    <RCAccordion
      heading={<span className="size-70 text-link">Record manual DC via PayPal refund and bill seller</span>}
      size="small"
      id="create-manual-dc-via-paypal-refund"
    >
      <div className="mb-4 bg-color-gray-100 padding-4 bd-2 bd-color-gray-300 bd-radius-md">
        <CsrfForm
          action={Paths.adminMarkDcViaPaypalOrderRefunded.expand({ orderId })}
          method="POST"
        >
          <div className="mb-4">
            <RCAlertBox
              type="warning"
            >
              This form should be used after a manual payment is sent to the buyer via the PayPal website.
              Submitting this form will bill the seller and (for full refunds) mark the order refunded.
            </RCAlertBox>
          </div>

          <RCRadioGroup
            required
            id="refund_type"
            label="Refund Type"
            value={formData.refundType}
            onChange={handleRefundTypeChange}
            name="refund_type"
          >
            <RCRadioGroup.Option
              label="Full"
              value={FULL}
            />
            <RCRadioGroup.Option
              label="Partial"
              value={PARTIAL}
            />
          </RCRadioGroup>
          { formData.refundType === PARTIAL && (
            <RCTextInput
              helpText="Full amount of payment sent to buyer"
              id="refund_amount"
              name="refund_amount"
              label="Refund Amount"
              onChange={handleRefundAmountChange}
              prefixText={CURRENCY_DESCRIPTION[presentmentCurrency]?.symbol}
              required
              suffixText={presentmentCurrency}
              value={formData.refundAmount}
            />
          )}
          <RCButton
            isSubmit
            variant="filled"
          >
            Mark Refunded and Bill Seller
          </RCButton>
        </CsrfForm>
      </div>
    </RCAccordion>

  );
}

export default AdminCreateManualDCViaPaypalRefundForm;
